import React from 'react';
import { motion } from 'framer-motion';
import { WarningIcon, XIcon } from './icons';
import { useLanguage } from '../context/LanguageContext';
export function WhyOthersFail() {
  const {
    t
  } = useLanguage();
  const failures = t('whyFail.items');
  return <section className="py-24 bg-brand-bg-light" data-id="element-367">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-368">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-369">
          <div className="flex items-center justify-center gap-4 mb-12" data-id="element-370">
            <WarningIcon className="w-10 h-10 text-brand-red" data-id="element-371" />
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-white text-center" data-id="element-372">
              {t('whyFail.title')}
            </h2>
          </div>

          <p className="text-xl text-gray-300 text-center mb-12" data-id="element-373">
            {t('whyFail.subtitle')}
          </p>

          <div className="space-y-6 mb-16" data-id="element-374">
            {Array.isArray(failures) && failures.map((item: any, index: number) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex items-start gap-4 bg-brand-bg-dark p-6 rounded-lg border border-brand-red/20 hover:border-brand-red/50 transition-colors" data-id="element-375">
                  <div className="mt-1 bg-brand-red/10 p-2 rounded-full flex-shrink-0" data-id="element-376">
                    <XIcon className="w-6 h-6 text-brand-red" data-id="element-377" />
                  </div>
                  <div data-id="element-378">
                    <h3 className="text-xl font-bold text-white mb-2" data-id="element-379">
                      {item.title}
                    </h3>
                    <p className="text-gray-400 text-lg" data-id="element-380">{item.desc}</p>
                  </div>
                </motion.div>)}
          </div>

          <div className="bg-brand-red/5 border-l-4 border-brand-red p-8 rounded-r-lg" data-id="element-381">
            <p className="text-xl sm:text-2xl text-white mb-4" data-id="element-382">
              {t('whyFail.conclusion1')}
              <strong className="text-brand-red font-heading tracking-wide" data-id="element-383">
                {t('whyFail.conclusion1_strong')}
              </strong>
            </p>
            <p className="text-lg text-gray-300 italic" data-id="element-384">
              {t('whyFail.conclusion2')}
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}